import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToasterService } from '@headpower/layout';
import { BlahService } from '@headpower/blah-ng';

@Component({
    selector: 'app-save-button',
    templateUrl: './save-button.component.html',
    styleUrls: ['./save-button.component.scss'],
    animations: [
        trigger('fade', [
            state('visible', style({ opacity: 1 })),
            state('hidden', style({ opacity: 0 })),
            state('visibleText', style({ opacity: 1 })),
            state('hiddenText', style({ opacity: 0 })),
            state('visibleMobile', style({ opacity: 1 })),
            state('hiddenMobile', style({ opacity: 0 })),

            transition('hidden => visible', animate('1s 1s ease-in-out')),  //1s delay so that it begins always after rotate animation (1s)
            transition('visible => hidden', animate('1s ease-in-out')),

            transition('hiddenText <=> visibleText', animate('1s ease-in-out')),
            transition('hiddenMobile <=> visibleMobile', animate('1s ease-in-out')),
        ]),
        trigger('rotateAnimation', [
            state('rotated', style({
                transform: 'rotate(360deg)'
            })),
            transition('* => rotated', [
                animate('1s')
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaveButtonComponent implements OnInit, OnChanges {

    @Input() mobile: boolean = false;
    @Input() savingState: string = 'default'; //default, saving ,saved or error

    public saveButtonState: string = 'default';
    private rotateState: string = '';
    private showingAnimation: boolean = false;
    private clickedAnimation: boolean = false;
    private animationType: string = 'saveText'; //rotation, saveText
    public errorState: boolean = false; //error state when saving failed or offline. Can be cleared only by refreshing page

    constructor(private cdRef: ChangeDetectorRef,
        private toaster: ToasterService,
        private blahService: BlahService,
    ) { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.savingState && !changes.mobile) {
            if (!navigator.onLine && changes.savingState.currentValue === 'error') {
                this.errorState = true;
                this.saveButtonState = 'offline';
                this.toaster.create(this.blahService.blah('error.http.offline'));
                return

            } else if (this.savingState === 'error') {
                this.saveButtonState = 'error';
                this.errorState = true;
                this.toaster.create(this.blahService.blah('default.saveFailed'));
                return
            }

            if (this.animationType === 'rotation') {
                if (this.savingState === 'saving' && !this.showingAnimation && !this.clickedAnimation && this.saveButtonState === 'default') {
                    this.saveButtonState = 'saving';
                    this.showingAnimation = true;
                    this.rotateState = 'rotated';
                } else if (this.savingState === 'saved' && this.saveButtonState === 'saving') {
                    this.saveButtonState = 'saved';
                    setTimeout(() => { this.saveButtonState = 'default', this.cdRef.markForCheck(); }, 2000);
                    setTimeout(() => { this.showingAnimation = false, this.rotateState = '', this.cdRef.markForCheck(); }, 3000);
                }
            } else {
                if (this.savingState === 'saved' && !this.showingAnimation && !this.clickedAnimation && changes.savingState.previousValue === 'saving') {
                    this.showingAnimation = true;
                    setTimeout(() => { this.saveButtonState = 'saved', this.cdRef.markForCheck(); }, 0);
                    setTimeout(() => { this.saveButtonState = 'default', this.cdRef.markForCheck(); }, 1500);
                    setTimeout(() => { this.showingAnimation = false, this.cdRef.markForCheck(); }, 2500);  //Here you can adjust time when next animation can start
                }
            }
            this.cdRef.markForCheck();
        }
    }

    public saveInfo() {
        if ((this.saveButtonState !== 'saving' && this.saveButtonState !== 'saved') && !this.showingAnimation && !this.clickedAnimation) {
            this.clickedAnimation = true
            setTimeout(() => { this.saveButtonState = 'saved', this.cdRef.markForCheck(); }, 0);
            setTimeout(() => { this.saveButtonState = 'default', this.cdRef.markForCheck(); }, 1500);
            setTimeout(() => { this.clickedAnimation = false, this.cdRef.markForCheck(); }, 2500);
        }
        this.cdRef.markForCheck();
    }
}
